import * as Constants from '../Constants'
import { createAsyncThunk } from '@reduxjs/toolkit';


function CreateBasicThunk(name, path) {
  return createAsyncThunk(name, async () => {

    //let pageSize = 10;
    try {
      var myHeaders = new Headers();
      myHeaders.append("X-Api-Key", "ApiKeyTest");
      myHeaders.append('Access-Control-Allow-Origin', Constants.PATH);
      myHeaders.append('Access-Control-Allow-Credentials', 'true');

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        dataType: "json"
      };
      const queryParams = new URLSearchParams({
        oznakaMesta: Constants.UNIVERSE,
      }).toString();

      const fullUrl = `${Constants.API_ROOT}${path}?${queryParams}`;


      const res = await fetch(fullUrl, requestOptions);
      return res?.json();
    } catch (error) {
      return [];
    }


  });


}


export const fetchRecentDocuments = CreateBasicThunk("fetchRecentDocuments", `/api/Documents/GetRecentDocuments`);
export const fetchMedia = CreateBasicThunk("fetchMedia", `/api/Documents/GetMedia`);
export const fetchSvedocenja = CreateBasicThunk("fetchSvedocenja", `/api/Documents/GetSvedocenja`);
export const fetchBooks = CreateBasicThunk("fetchBooks", `/api/Documents/GetBooks`);
export const fetchDocuments = CreateBasicThunk("fetchDocuments", `/api/Documents/GetDocuments`);
export const fetchImages = CreateBasicThunk("fetchImages", `/api/Documents/GetImages`);
export const fetchGroups = CreateBasicThunk("fetchGroups", `/api/Documents/GetGroups`);
export const fetchRazno = CreateBasicThunk("fetchRazno", `/api/Documents/GetRazno`);
export const fetchWallpapersWide = CreateBasicThunk("fetchWallpapersWide", `/api/Documents/GetWallpapersWide`);
export const fetchWallpapersNarrow = CreateBasicThunk("fetchWallpapersNarrow", `/api/Documents/GetWallpapersNarrow`);
export const fetchRecentPosters = CreateBasicThunk("fetchRecentPosters", `/api/Posters/GetRecentPosters`);
